import { render } from "./ViewModeleNotificationPage.vue?vue&type=template&id=27f2b540&ts=true"
import script from "./ViewModeleNotificationPage.vue?vue&type=script&lang=ts"
export * from "./ViewModeleNotificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__